import ArcadeConfig, { ATTRIBUTES as ARCADE_CONFIG_ATTRIBUTES } from './data/arcadeConfig';
import './lib/modernizr-custom';
import { getLogger } from './logging/logger';

const logger = getLogger('Environment');

export default class Environment {
	static getSearchParam(param) {
		return new URLSearchParams(window.location.search).get(param);
	}

	static isLocal() {
		return /(local|ngrok\.io)/.test(window.location.origin.toLowerCase());
	}

	static isDev() {
		return /dev/.test(window.location.origin.toLowerCase());
	}

	static isDebug() {
		return /true/i.test(this.getSearchParam('debug'));
	}

	static isProd() {
		return !this.isDev() && !this.isLocal();
	}

	/**
	 * Checks if STB on any supported platforms
	 */
	static isSetTopBox() {
		return (
			this.isComcastSetTopBox() ||
			this.isVerizonSetTopBox() ||
			/STB/.test(this.getSearchParam('utm_medium'))
		);
	}

	/**
	 * Checks if Comcast/Cox STB
	 */
	static isComcastSetTopBox() {
		return /NativeXREReceiver/.test(navigator.userAgent) || /WPE/.test(navigator.userAgent);
	}

	/**
	 * Checks if Verizon STB
	 */
	static isVerizonSetTopBox() {
		return /(Verizon|KreaTV)/.test(navigator.userAgent);
	}

	static isVMS1100() {
		return /VMS1100/.test(navigator.userAgent);
	}

	static isMTheory() {
		return /M-Theory-Chromium/.test(navigator.userAgent);
	}

	static needsVideoControls() {
		return (
			(!this.isMTheory() && !this.isSetTopBox() && !window.Modernizr.videoautoplay) ||
			this.isLocal()
		);
	}

	static isKidsVariant() {
		return /hwpHubKids/.test(this.getSearchParam('utm_campaign'));
	}

	static isVerizon() {
		return /verizon/i.test(this.getSearchParam('utm_source'));
	}

	static isHub() {
		return (
			/\/hwpHub(?!Games).*\//.test(window.location.pathname) ||
			/^hwpHub(?!Games).*$/.test(ArcadeConfig.get(ARCADE_CONFIG_ATTRIBUTES.arcadeName))
		);
	}

	static isInHub() {
		if (!document.referrer) {
			return false;
		}

		if (this.isLocal()) {
			// Determine if the referrer was running on a different port. Assume this means it's the hub and we are child.
			const referrer = new URL(document.referrer);
			const referrerPort = referrer.port;
			const locationPort = window.location.port;

			logger.debug({ referrerPort, locationPort });
			return !!referrerPort && !!locationPort && referrerPort !== locationPort;
		}

		// second check: iff in hub, loaded a module into self, always loads index and !test|demo
		return (
			/hollywoodplayer.com\/hwpHub(?!Games).*\//.test(document.referrer) &&
			!/(test|demo).html/.test(document.referrer)
		);
	}
}
